import React from "react";
import Navbar from "../../../components/Navbar";
import BackToTop from "../../../components/BackToTop";
import { Container, NavbarGroup, Content } from "../style";
import {
  PromessaBox,
  InfoCallout,
  AlertCallout,
  SuccessCallout,
  DangerCallout,
  MarcoBox,
  ChecklistItem,
} from "./style";

const AIJourney_v1_Visual = () => {
  return (
    <Container>
      <Container id="back-to-top-anchor" />
      <Navbar />

      <NavbarGroup aria-label="Conteúdo da página">
        <p>Índice</p>

        <ul>
          <li>
            <a href="#a">
              <span>
                <strong>A.</strong> A Promessa
              </span>
            </a>
          </li>

          <li>
            <a href="#1">
              <span>
                <strong>1.</strong> Qualificação das Partes
              </span>
            </a>
          </li>

          <li>
            <a href="#2">
              <span>
                <strong>2.</strong> Regras de Participação
              </span>
            </a>
          </li>

          <li>
            <a href="#3">
              <span>
                <strong>3.</strong> Como Solicitar o Reembolso
              </span>
            </a>
          </li>

          <li>
            <a href="#4">
              <span>
                <strong>4.</strong> Quando a Garantia Não se Aplica
              </span>
            </a>
          </li>

          <li>
            <a href="#5">
              <span>
                <strong>5.</strong> Tratamento de Dados Pessoais
              </span>
            </a>
          </li>

          <li>
            <a href="#6">
              <span>
                <strong>6.</strong> Disposições Gerais
              </span>
            </a>
          </li>

          <li>
            <a href="#resumo">
              <span>Resumo</span>
            </a>
          </li>
        </ul>
      </NavbarGroup>

      <Content>
        <h1 style={{ marginTop: 50 }}>AI Journey 2026</h1>
        <p style={{ color: "#6B7280", fontStyle: "italic", paddingTop: 0 }}>
          Garantia de ROI em 180 dias · Termo de Aceite
        </p>

        <p id="a">
          <strong>A. A Promessa</strong>
        </p>

        <PromessaBox>
          <p>
            <strong>
              Se em 180 dias você não identificar uma ferramenta de IA, construir um time de agentes
              ou automatizar um processo utilizando IA que pague o investimento, devolvemos 100% do
              valor que você pagou.
            </strong>
          </p>
          <p>
            <em>Para isso, é necessário cumprir as regras descritas neste documento.</em>
          </p>
        </PromessaBox>

        <InfoCallout>
          <h4>Por que existem regras?</h4>
          <p>
            A garantia é real. Mas para que ela funcione, você precisa ter participado de fato do
            programa. As regras abaixo garantem que a StartSe cumpriu sua parte — e que você cumpriu
            a sua.
          </p>
        </InfoCallout>

        <p id="1" style={{ marginTop: 32 }}>
          <strong>1. Qualificação das Partes</strong>
        </p>

        <p>
          <strong>Contratada:</strong> StartSe Informações e Sistemas S.A., inscrita no CNPJ sob o
          n.º 24.554.736/0001-70, com sede na Avenida das Nações Unidas, 12901 – CENU Torre Norte 9
          Andar – Cidade Monções – São Paulo/SP, doravante denominada simplesmente StartSe.
        </p>

        <p>
          <strong>Contratante / Participante:</strong> Pessoa física ou jurídica identificada no ato
          da compra, cujos dados (nome completo ou razão social, CPF ou CNPJ, e-mail e telefone)
          constam no cadastro da plataforma da StartSe, doravante denominada Participante.
        </p>

        <p id="2" style={{ marginTop: 32 }}>
          <strong>2. Regras de Participação</strong>
        </p>

        <p style={{ color: "#0080ED" }}>
          <strong>Regra 1 — Participação mínima de 80% do programa</strong>
        </p>
        <p>
          A participação é medida como média ponderada de 5 frentes. Algumas pesam mais, outras
          menos:
        </p>

        <table>
          <thead>
            <tr>
              <th>Frente</th>
              <th>Peso</th>
              <th>O que conta</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Diagnóstico e Planejamento</strong>
              </td>
              <td>10%</td>
              <td>
                Diagnóstico de Maturidade, Planejamento, Entregar AI Canvas + 1 caso de uso
                selecionado
              </td>
            </tr>
            <tr>
              <td>
                <strong>Trilhas online (6 trilhas)</strong>
              </td>
              <td>35%</td>
              <td>Concluir os módulos na plataforma</td>
            </tr>
            <tr>
              <td>
                <strong>Imersões presenciais (2)</strong>
              </td>
              <td>10%</td>
              <td>Estar presente nos eventos (check-in)</td>
            </tr>
            <tr>
              <td>
                <strong>Encontros ao vivo: Radar IA, Elite Sessions, Mentorias técnicas</strong>
              </td>
              <td>30%</td>
              <td>Participar de pelo menos 8 dos 12 do ano</td>
            </tr>
            <tr>
              <td>
                <strong>Sessões com Concierge</strong>
              </td>
              <td>5%</td>
              <td>Realizar no mínimo 6 conversas 1:1 nos 6 meses</td>
            </tr>
            <tr>
              <td>
                <strong>Toolkit AI</strong>
              </td>
              <td>10%</td>
              <td>Utilizar pelo menos 10 agentes</td>
            </tr>
          </tbody>
        </table>

        <InfoCallout>
          <h4>Na prática</h4>
          <p>
            Você pode faltar a uma imersão e ainda ter direito à garantia, desde que tenha pontuação
            alta nas outras frentes. O que importa é a média ponderada chegar a 80% ao final dos 180
            dias.
          </p>
        </InfoCallout>

        <p style={{ color: "#0080ED", marginTop: 24 }}>
          <strong>Regra 2 — Cumprimento dos 5 marcos obrigatórios</strong>
        </p>
        <p>
          Os 80% acima são uma média — você tem flexibilidade para distribuir. Mas existem 5 ações
          que precisam ser cumpridas individualmente, sem exceção. Mesmo que você atinja 95% da
          participação geral, o descumprimento de qualquer um dos marcos abaixo extingue o direito à
          garantia.
        </p>

        <MarcoBox>
          <div className="marco-number">1</div>
          <div className="marco-body">
            <h4>Fazer o Diagnóstico de Maturidade</h4>
            <p>
              <strong>O que você precisa fazer:</strong> Participar do assessment, fornecer as
              informações pedidas e receber o relatório executivo da sua empresa.
            </p>
            <p>
              <strong>Até quando:</strong> Nos primeiros 30 dias do programa.
            </p>
          </div>
        </MarcoBox>

        <MarcoBox>
          <div className="marco-number">2</div>
          <div className="marco-body">
            <h4>Validar o Roadmap de Adoção</h4>
            <p>
              <strong>O que você precisa fazer:</strong> Participar das sessões de construção do
              roadmap, validar formalmente o documento (assinatura ou e-mail de aceite) e ter pelo
              menos 1 quick win identificado para os 90 dias seguintes.
            </p>
            <p>
              <strong>Até quando:</strong> Nos primeiros 60 dias do programa.
            </p>
          </div>
        </MarcoBox>

        <MarcoBox>
          <div className="marco-number">3</div>
          <div className="marco-body">
            <h4>Participar de pelo menos 1 imersão presencial</h4>
            <p>
              <strong>O que você precisa fazer:</strong> Estar presente em pelo menos 1 das 2
              imersões oferecidas no ano (IA para Negócios ou Multiagentes), com check-in no evento.
            </p>
            <p>
              <strong>Até quando:</strong> Em qualquer momento dentro dos 180 dias.
            </p>
          </div>
        </MarcoBox>

        <MarcoBox>
          <div className="marco-number">4</div>
          <div className="marco-body">
            <h4>Indicar um sponsor C-Level por escrito</h4>
            <p>
              <strong>O que você precisa fazer:</strong> Designar formalmente, por e-mail ou pelo
              Concierge, qual executivo (CEO, CIO, CFO, COO ou equivalente) é o patrocinador interno
              do programa na sua empresa.
            </p>
            <p>
              <strong>Até quando:</strong> Nos primeiros 30 dias do programa.
            </p>
          </div>
        </MarcoBox>

        <MarcoBox>
          <div className="marco-number">5</div>
          <div className="marco-body">
            <h4>Realizar pelo menos 10 encontros ao vivo</h4>
            <p>
              <strong>O que você precisa fazer:</strong> Participar de pelo menos 10 encontros ao
              vivo distribuídos entre Elite Sessions, Mentorias e Radar de IA.
            </p>
            <p>
              <strong>Até quando:</strong> Distribuídos ao longo dos 180 dias.
            </p>
          </div>
        </MarcoBox>

        <AlertCallout>
          <h4>Dica importante</h4>
          <p>
            A StartSe vai lembrar de cada marco pelo canal do Concierge. Mas a responsabilidade de
            cumprir é do Participante. O descumprimento de qualquer um dos 5 marcos extingue o
            direito à garantia, independentemente da participação nas demais frentes.
          </p>
        </AlertCallout>

        <p style={{ color: "#0080ED", marginTop: 24 }}>
          <strong>Regra 3 — Aplicação prática: Relatório de Conclusão</strong>
        </p>
        <p>
          Não basta participar. Para acionar a garantia, é necessário demonstrar que houve tentativa
          real de aplicar o conteúdo. Ao solicitar o reembolso, o Participante deverá enviar um
          Relatório de Conclusão contendo:
        </p>
        <ul style={{ paddingLeft: 24 }}>
          <li>
            <strong>
              Lista das ferramentas de IA testadas durante os 180 dias, com data do teste e
              responsável interno.
            </strong>
          </li>
          <li>
            <strong>
              Pelo menos 2 casos de uso piloto implementados (mesmo que parcialmente) em alguma área
              da empresa.
            </strong>
          </li>
          <li>
            <strong>
              Cálculo do retorno esperado de cada caso (payback, redução de custo ou aumento de
              receita projetados em 12 meses) — demonstrando que nenhum atingiu R$ 12.000,00.
            </strong>
          </li>
          <li>
            <strong>
              Descrição das barreiras encontradas (técnicas, organizacionais ou de mercado) que
              impediram o ROI.
            </strong>
          </li>
          <li>
            <strong>
              Declaração formal do sponsor C-Level (Marco 4) confirmando as informações do
              Relatório.
            </strong>
          </li>
        </ul>

        <InfoCallout>
          <h4>Por que pedimos isso?</h4>
          <p>
            Sem evidência de que o Participante tentou aplicar o conteúdo, não há como distinguir
            entre falta de ROI e falta de execução. O Relatório protege tanto o Participante quanto
            a StartSe.
          </p>
        </InfoCallout>

        <p id="3" style={{ marginTop: 32 }}>
          <strong>3. Como Solicitar o Reembolso</strong>
        </p>

        <p style={{ color: "#0080ED" }}>
          <strong>3.1 — Janela de solicitação</strong>
        </p>
        <p>O Participante tem uma janela de 30 dias para protocolar a solicitação:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>
            A solicitação não pode ser feita antes do dia 181 (antes do término dos 180 dias de
            programa).
          </li>
          <li>
            A solicitação não pode ser feita após o dia 210 (após esse prazo, extingue-se o
            direito).
          </li>
        </ul>

        <p style={{ color: "#0080ED", marginTop: 16 }}>
          <strong>3.2 — Passo a passo</strong>
        </p>
        <ul style={{ paddingLeft: 24 }}>
          <li>
            Envie o Relatório de Conclusão para garantia@startse.com com o assunto 'GARANTIA ROI – AI
            JOURNEY 2026 – [seu nome completo]'.
          </li>
          <li>A StartSe confirmará o recebimento em até 5 dias úteis.</li>
          <li>
            Um comitê interno (Produto + Comercial + Jurídico) avaliará a solicitação em até 20 dias
            úteis.
          </li>
          <li>Se necessário, a StartSe agendará uma reunião de validação com o Participante.</li>
          <li>
            A decisão será comunicada por escrito, com justificativa, no prazo de até 25 dias úteis
            a contar do protocolo.
          </li>
        </ul>

        <p style={{ color: "#0080ED", marginTop: 16 }}>
          <strong>3.3 — Contestação da decisão</strong>
        </p>
        <p>
          Caso o Participante discorde da decisão do comitê, poderá apresentar contestação por
          escrito em até 5 dias úteis após o recebimento da resposta, pelo mesmo canal
          (garantia@startse.com). A StartSe analisará a contestação em até 10 dias úteis adicionais.
        </p>

        <p style={{ color: "#0080ED", marginTop: 16 }}>
          <strong>3.4 — Prazo e valor do reembolso</strong>
        </p>
        <p>
          Se aprovado, o reembolso será processado em até 10 dias úteis após a aprovação final.
        </p>
        <p>
          <strong>
            O valor devolvido corresponde a 100% do valor efetivamente pago pelo Participante, sem
            qualquer dedução.
          </strong>
        </p>

        <p id="4" style={{ marginTop: 32 }}>
          <strong>4. Quando a Garantia Não se Aplica</strong>
        </p>

        <p>
          Para total transparência, listamos abaixo todas as situações em que a garantia não é
          devida. Recomendamos a leitura atenta antes de aceitar este termo:
        </p>

        <DangerCallout>
          <h4>A garantia não se aplica quando:</h4>
          <ul>
            <li>
              O Participante não cumpriu algum dos 5 marcos obrigatórios (diagnóstico, roadmap,
              imersão, sponsor C-Level ou encontros ao vivo).
            </li>
            <li>
              O Participante não atingiu 80% de participação na média ponderada das 5 frentes do
              programa.
            </li>
            <li>
              O Participante saiu da empresa antes do 180º dia sem indicar um substituto C-Level que
              assumisse o programa nos 30 dias seguintes.
            </li>
            <li>
              Foram detectadas informações falsas ou indícios de má-fé no Relatório de Conclusão.
            </li>
            <li>
              O Participante está inadimplente com o pagamento do programa na data da solicitação.
            </li>
            <li>
              A solicitação foi protocolada fora da janela prevista (antes do dia 181 ou após o dia
              210).
            </li>
            <li>
              O Participante compartilhou ou revendeu o acesso ao programa para terceiros não
              autorizados.
            </li>
          </ul>
        </DangerCallout>

        <InfoCallout>
          <h4>Nota sobre dificuldades internas de implementação</h4>
          <p>
            Reconhecemos que cada empresa tem sua própria dinâmica. Caso você enfrente obstáculos
            organizacionais relevantes durante o programa, entre em contato com o Concierge antes do
            término dos 180 dias. A StartSe poderá avaliar alternativas de suporte. Situações
            documentadas e comunicadas tempestivamente serão consideradas na análise do Relatório de
            Conclusão.
          </p>
        </InfoCallout>

        <p id="5" style={{ marginTop: 32 }}>
          <strong>5. Tratamento de Dados Pessoais (LGPD)</strong>
        </p>

        <p>
          Os dados pessoais e empresariais coletados durante o programa (incluindo diagnóstico de
          maturidade, roadmap, casos de uso e informações financeiras para cálculo de ROI) serão
          tratados pela StartSe exclusivamente para as seguintes finalidades:
        </p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Execução do contrato e entrega do programa AI Journey 2026.</li>
          <li>Análise das solicitações de reembolso no âmbito desta Garantia de ROI.</li>
          <li>
            Melhoria contínua dos produtos e serviços da StartSe, sempre de forma anonimizada.
          </li>
        </ul>
        <p>
          O tratamento obedece às disposições da Lei Geral de Proteção de Dados (Lei 13.709/2018).
          Para exercer seus direitos de acesso, correção, portabilidade ou eliminação de dados,
          acesse a Política de Privacidade completa em startse.com/privacidade ou entre em contato
          pelo e-mail privacidade@startse.com.
        </p>

        <p id="6" style={{ marginTop: 32 }}>
          <strong>6. Disposições Gerais</strong>
        </p>

        <p>
          <strong>6.1 Foro:</strong> Fica eleito o foro do domicílio do Participante para dirimir
          quaisquer controvérsias decorrentes deste termo, sem prejuízo do direito de o Participante
          acionar o Juizado Especial Cível da sua localidade.
        </p>
        <p>
          <strong>6.2 Lei aplicável:</strong> O presente termo é regido pelas leis brasileiras, em
          especial pelo Código de Defesa do Consumidor (Lei 8.078/1990) e pelo Código Civil (Lei
          10.406/2002).
        </p>
        <p>
          <strong>6.3 Vigência:</strong> Este termo entra em vigor na data do aceite eletrônico pelo
          Participante e permanece vigente pelo período do programa e durante o prazo de
          solicitação da garantia (até o dia 210 a contar do início do programa).
        </p>
        <p>
          <strong>6.4 Registro do aceite:</strong> O aceite eletrônico será registrado com data,
          hora e identificação do Participante, constituindo prova de ciência e concordância com
          todos os termos aqui estabelecidos.
        </p>

        <p id="resumo" style={{ marginTop: 32, color: "#0080ED" }}>
          <strong>✓. Resumo: O que você precisa fazer</strong>
        </p>

        <p>Para ter direito à garantia, cumpra os itens abaixo:</p>

        <ChecklistItem>Atingir 80% de participação na média ponderada do programa</ChecklistItem>
        <ChecklistItem>Fazer o Diagnóstico de Maturidade nos primeiros 30 dias</ChecklistItem>
        <ChecklistItem>Validar o Roadmap de Adoção nos primeiros 60 dias</ChecklistItem>
        <ChecklistItem>Indicar um sponsor C-Level nos primeiros 30 dias</ChecklistItem>
        <ChecklistItem>
          Participar de pelo menos 1 imersão presencial dentro dos 180 dias
        </ChecklistItem>
        <ChecklistItem>
          Realizar pelo menos 10 sessões ao vivo distribuídas nos 180 dias
        </ChecklistItem>
        <ChecklistItem>Testar pelo menos 2 casos de uso de IA na sua empresa</ChecklistItem>
        <ChecklistItem>Enviar o Relatório de Conclusão entre os dias 181 e 210</ChecklistItem>

        <SuccessCallout>
          <h4>Se cumprir tudo isso e o ROI não aparecer:</h4>
          <p>
            Devolvemos 100% do valor pago. Sem letras miúdas além das que você acabou de ler.
          </p>
        </SuccessCallout>

        <p style={{ marginTop: 24, color: "#0080ED" }}>
          <strong>Ao clicar em 'Aceitar e Contratar', o Participante declara que:</strong>
        </p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Leu e compreendeu integralmente este Termo de Aceite;</li>
          <li>Concorda com as regras, marcos e condições aqui estabelecidos;</li>
          <li>
            Autoriza o tratamento de seus dados pessoais para as finalidades descritas na Seção 5.
          </li>
        </ul>
      </Content>
      <BackToTop />
    </Container>
  );
};

export default AIJourney_v1_Visual;
